import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { useMemo } from "react";
import AccountActions from "./account";
import ApplicationActions from "./application";
import AnnouncementActions from "./announcement";
import CampaignActions from "./campaign";
import VehicleActions from "./vehicle";

export const ActionCreators = {
  AccountActions,
  ApplicationActions,
  AnnouncementActions,
  CampaignActions,
  VehicleActions,
};

export function useActions(actions, deps) {
  const dispatch = useDispatch();
  return useMemo(
    () => {
      if (Array.isArray(actions)) {
        return actions.map((a) => bindActionCreators(a, dispatch));
      }
      return bindActionCreators(actions, dispatch);
    },
    deps ? [dispatch, ...deps] : [dispatch]
  );
}

export default ActionCreators;
